import React, { useCallback, useEffect, useState } from "react";

import { ArcElement, Chart as ChartJS, Legend, Tooltip, } from 'chart.js';
import { Button, Card, Container } from "react-bootstrap";
import { Doughnut } from 'react-chartjs-2';
import {
    getDataFromUserStats,
    getLeadsValue,
} from "../../services/Leadservice";
import LoadingLoginScreen from "../LoadingLoginScreen";
import { getAllUsersFromCompany } from "../../services/AdminService";
import { hexToRGB } from "../../UTILS/UtilFunctions";

ChartJS.register(ArcElement, Tooltip, Legend);


export const LineStatistics = ({ company }) => {


    const [value, setValue] = useState(0);

    const [users, setUsers] = useState([]);
    const [userObjects, setUserObjects] = useState([]);
    const [loading, setLoading] = useState(false)


    const fetchUserLeadValue = useCallback(async () => {
        try {
            setLoading(true);

            const companyUsers = await getAllUsersFromCompany(company);
            const getUserLeads = await getDataFromUserStats(company);
            setUsers(companyUsers);

            setUserObjects(getUserLeads);

            setLoading(false);
            let val = await getLeadsValue(company);
            setValue(val);

        } catch (e) {
        }
    });




    useEffect(() => {
        fetchUserLeadValue().then(() => {

        })


    }, [company])


    const data = {



        datasets: [
            {
                label: `Användare: ${users.length}`,
                data: userObjects,
                backgroundColor: hexToRGB("#800000"),
                borderColor: 'rgb(255,255,255)',
                borderWidth: 2,
            },
        ],
    };

    return (

        <Container>
            {loading ? (
                <LoadingLoginScreen />
            ) : (
                <Container style={{ width: '55%' }}>
                    Totalt värde: {value}kr
                    <Doughnut data={data} type={""} />
                </Container>
            )
            }
        </Container>
    )

}
